module.exports = __webpack_public_path__ + "static/img/crude-oil_256.506f4b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crude-oil_256.png
// module id = WzHx
// module chunks = 0